import { render, staticRenderFns } from "./childdealerintegrallog.vue?vue&type=template&id=50681f93&"
import script from "./childdealerintegrallog.vue?vue&type=script&lang=js&"
export * from "./childdealerintegrallog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports